/*
 * Copyright 2020 AlexaCRM
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
 * associated documentation files (the "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
 * PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
 * BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
 * OR OTHER DEALINGS IN THE SOFTWARE.
 */

import Vue from 'vue'
import forOwn from 'lodash/forOwn'

export const TYPE_V2_CHECKBOX = 'v2-checkbox',
  TYPE_V2_INVISIBLE = 'v2-invisible',
  TYPE_V3 = 'v3'

export const THEME_LIGHT = 'light',
  THEME_DARK = 'dark'

export const SIZE_NORMAL = 'normal',
  SIZE_COMPACT = 'compact'

export const BADGE_BOTTOMRIGHT = 'bottomright',
  BADGE_BOTTOMLEFT = 'bottomleft',
  BADGE_INLINE = 'inline'

export default {
  state: {
    adapterName: 'default',
    type: null,
    siteKey: '',
    secretKey: '',
    theme: THEME_LIGHT,
    size: SIZE_NORMAL,
    badge: BADGE_BOTTOMRIGHT,
    scoreThreshold: 0.5,
    action: null,
  },
  mutations: {
    initialize(state, init) {
      forOwn(init, (v, k) => { Vue.set(state, k, v) })
    },
    updateValues(state, data) {
      forOwn(data, (v, k) => { Vue.set(state, k, v) })
    },

    setAdapterName(state, v) {
      state.adapterName = v
    },
    setType(state, v) {
      state.type = v
    },
    setSiteKey(state, v) {
      state.siteKey = v
    },
    setSecretKey(state, v) {
      state.secretKey = v
    },
    setTheme(state, v) {
      state.theme = v
    },
    setSize(state, v) {
      state.size = v
    },
    setBadge(state, v) {
      state.badge = v
    },
    setScoreThreshold(state, v) {
      state.scoreThreshold = v
    },
  },
  actions: {},
  namespaced: true,
}
